import EventConstants from '../../constants/EventConstants'
import { AxiosUtil } from '../../utils/axios-util'
import {
  errorNotification,
  successNotification,
  errorResponseNotification,
} from '../notification-service'
import { saveAs } from 'file-saver'
import { PreISUProductsResponse } from '../../models/products/preISUProductsResponse'

export const getRequestVendorPreIsuProducts = ({
  eventId,
  page,
  perPage,
  request,
}): Promise<PreISUProductsResponse> => {
  const url =
    EventConstants.EVENT +
    eventId +
    '/product/assortments?' +
    'page=' +
    page +
    '&per_page=' +
    perPage
  return AxiosUtil.post(url, request)
    .then(resp => {
      return resp.data
    })
    .catch(err => {
      errorResponseNotification(err)
      throw err
    })
}

export const saveVendorPreIsu = (eventId, request) => {
  const url = EventConstants.EVENT + eventId + '/product/assortments'
  return AxiosUtil.put(url, request).catch(err => {
    errorResponseNotification(err)
    throw err
  })
}

export const exportToExcel = ({ fileName, eventId, totalCount, request }) => {
  const url =
    EventConstants.EVENT +
    eventId +
    '/product/assortments/excel?total_count=' +
    totalCount

  return AxiosUtil.post(url, request, {
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    responseType: 'blob',
  })
    .then(res => {
      const blob = new Blob([res.data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      })
      saveAs(blob, fileName + '.xlsx')
      successNotification(['Excel sheet downloaded successfully.'])
    })
    .catch(err => {
      errorNotification([
        'Failed to download the Excel. Something went wrong while fetching the data.',
      ])
    })
}
